import { useEffect, useState } from "react";
import FilterBar from "./FilterBar";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LabelList,
  Cell
} from "recharts";
import api from "../../../../services/api";

function PanoBarChart() {
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState({});

  // PALETA DE CORES PARA CADA BARRA
  const cores = [
    "#ff0707ff", // Simples
    "#ffee02ff", // Especial
    "#fcb900ff", // Ouro
    "#acacacff", // Prata
    "#ff9011ff", // Bronze
    "#09acecff", // Maleta
  ];

  async function carregar(params = {}) {
    try {
      const res = await api.get("/v1/dashboard/pano", {
        params: {
          dt1: params.inicio || "",
          dt2: params.fim || "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const r = res.data || {};

      const arr = [
        { nome: "Simples", quantidade: r.qtdesimples || 0 },
        { nome: "Especial", quantidade: r.qtdeespecial || 0 },
        { nome: "Ouro", quantidade: r.qtdeouro || 0 },
        { nome: "Prata", quantidade: r.qtdeprata || 0 },
        { nome: "Bronze", quantidade: r.qtdebronze || 0 },
        { nome: "Maleta", quantidade: r.qtdemaleta || 0 },
      ];

      setDados(arr);

    } catch (err) {
      console.error("Erro ao carregar tipos e panos:", err);
      setDados([]);
    }
  }

  return (
    <div className="dashboard-card">

      {/* HEADER */}
      <div className="header-row">
        <div className="dashboard-header">
          <i className="fa fa-tshirt"></i> Tipos de Pano
        </div>

        <button className="btn btn-outline-primary btn-sm btn-refresh" onClick={() => carregar(filtro)}>
          <i className="fa fa-sync"></i>
        </button>
      </div>

      <div className="dashboard-body">

        <FilterBar
          onChange={(f) => {
            setFiltro(f);
            carregar(f);
          }}
        />

        {/* GRÁFICO */}
        <div className="chart-area" style={{ width: "100%", height: "260px" }}>
          {dados.length === 0 ? (
            <div>Sem dados</div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={dados} barSize={50}>
                <CartesianGrid strokeDasharray="3 3" stroke="#ddd" />

                <XAxis dataKey="nome" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip contentStyle={{ fontSize: "14px" }} />

                <Bar
                  dataKey="quantidade"
                  radius={[8, 8, 0, 0]}
                  animationDuration={1200}
                  animationEasing="ease-out"
                >
                  {/* CORES DINÂMICAS POR BARRA */}
                  {dados.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={cores[index % cores.length]}
                    />
                  ))}

                  {/* VALOR EM CIMA DAS BARRAS */}
                  <LabelList
                    dataKey="quantidade"
                    position="top"
                    style={{ fill: "#333", fontWeight: "bold" }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}

export default PanoBarChart;
